import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreateReturnLossForm from '../CreateReturnLossForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function CreateReturnLossListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`สร้างกิจกรรมคืนยอดเสีย`}
					description="สร้างกิจกรรมคืนยอดเสีย"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateReturnLossForm />
		</div>
	)
}
